export enum FilterKeysEnum {
  CEREAL_CROPS = "cerealCrops",
  COUNTRY = "country",
  STATES = "states",
  PAYMENT_TYPES = "paymentTypes",
  CURRENCY = "currency",
}
